<template>
  <van-popup
    v-model="vanpopup"
    get-container="body"
  >
    <div
      style="width: 100vw;"
    >
      <iframe
        v-if="vanpopup"
        width="100%"
        height="250"
        scrolling="no"
        :src="videoSrc"
        frameborder="0"
        style="width: 100%"
      >
      </iframe>
    </div>
  </van-popup>
</template>

<script>
export default {
  name: 'WapVideo',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    lotteryCode: {
      type: String,
      default: '',
      required: false
    }
  },
  data() {
    return {
      videoLotteryType: ''
    }
  },
  computed: {
    computedLotteryCode() {
      return this.lotteryCode ? this.lotteryCode : this.$route.params.lottery_code
    },
    vanpopup: {
      get() {
        return this.show
      },
      set(value) {
        this.$emit('update:show', value)
      }
    },
    videoLotteryCode() {
      return this.computedLotteryCode
    },
    videoSrc() {
      const videoLotteryType = this.videoLotteryType
      const videoLotteryCode = this.videoLotteryCode

      return `/lottery-animation/${videoLotteryType}_video/index.html?lotteryCode=${videoLotteryCode}`
    }
  },
  watch: {
    videoLotteryCode: {
      immediate: true,
      async handler() {
        if (!this.computedLotteryCode) return // 有些頁面沒有lotteryCode

        const lotteryType = await this.$getLotteryType(this.computedLotteryCode)
        const videoLotteryType = this.getVideoLotteryType(this.computedLotteryCode, lotteryType)

        if (!videoLotteryType) {
          console.warn('videoLotteryType: 彩種對影影片類型失敗!')
        }
        this.videoLotteryType = videoLotteryType
      }
    }
  },
  methods: {
    getVideoLotteryType(lotteryCode, lotteryType) {
      switch (lotteryCode) {
        case 'fc3d':
        case 'fcssq':
        case 'pl3':
        case 'shssc':
          return 'fc3d'
        case 'cqxync':
          return 'cqnc'
        case 'twbingo':
          return 'twbg'
        case 'malxyft':
          return 'ft'
      }
      switch (lotteryType) {
        case '11x5':
        case 'k3':
        case 'pk10':
        case 'ssc':
          return lotteryType
        case 'hk6':
          return 'lhc'
        case 'kl10':
          return 'klsf'
        case 'xy28':
          return 'pcEgg'
        case 'kl8': // 暫無
          return 'twbg'
      }

      // 以下沒有直播
      // pl5: 排列5
      // qlc: 七乐彩
      // qxc: 七星彩
      // cjdlt: 超级大乐透
      return ''
    }
  }
}
</script>
